var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSegment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17908 1.74707C7.75049 1.74707 9.03619 3.03277 9.03619 4.60419C9.03619 6.1756 7.75049 7.4613 6.17908 7.4613C4.60766 7.4613 3.32196 6.1756 3.32196 4.60419C3.32196 3.03277 4.60766 1.74707 6.17908 1.74707ZM11.179 13.8898L12.4647 15.1541C12.8219 15.5112 13.3219 15.2255 13.3219 14.8041V11.747L15.3219 9.31843C15.679 8.81844 15.3219 8.17558 14.7504 8.17558H9.75047C9.17905 8.17558 8.82191 8.88986 9.17905 9.31843L11.179 11.747V13.8898ZM9.75047 12.247L8.10763 10.247C7.82192 9.88985 7.67906 9.46129 7.67906 9.03272C7.17907 8.88986 6.67907 8.88986 6.17908 8.88986C3.03625 8.88986 0.464844 10.1756 0.464844 11.747V13.1755C0.464844 13.5503 0.768645 13.8541 1.1434 13.8541H9.75047V12.247Z",
    fill: "#717B84"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSegment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Segment.660f0718f81ec3f412e5d375020c662e.svg";